import React from 'react'
import { Link } from 'react-router-dom'
import pluralize from 'pluralize'
import _ from 'lodash'
import StudentRosterForm from './StudentRosterForm'
import StudentsForm from './StudentsForm'
import SectionFormInline from './SectionFormInline'
import GoogleClassroomPopup from './GoogleClassroomPopup'
import ConfirmationPopup from '../../components/ConfirmationPopup'
import TransferStudentsFormPopup from './TransferStudentsFormPopup'
import HintButton from '../../components/HintButton'
import VerticalTabBox from '../../components/VerticalTabBox'
import RemoveStudentsForm from './RemoveStudentsForm'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import { faCircle, faAdjust } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../assets/css/pages/class_management/section.css'
import Switch from 'react-switchery'
import { OnboardingTeacherContext } from '../../contexts/OnboardingTeacherContextProvider'
import {convertStudentStartTrack, handleTaskComplete, status, step_id} from '../../components/OnboardingHomepage/onboardingUtils'

class Section extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showResetConfirmation: false,
      autoGenerate: true,                               // For usernames/passwords for Manually Add students
      wasManuallyAddStudentsSuccessful: true,           // Success status used to display a banner when students are added successfully
      isEditingRoster: false,
      isRemovingStudents: false,
      isDeleteStudentsPopupOpen: false,
      isTransferStudentsPopupOpen: false,
      transferStudentsSuccess: false,
      studentsForRemoval: [],                                 //staging area for students to be deleted/transfered
      courseValue: _.isEmpty(props.section) ? {} : {
        value: props.section.course.id,
        name: props.section.course.name
      }
    }
  }

  handleManuallyAddStudentsSuccess = ()=> {
    this.setState({ wasManuallyAddStudentsSuccessful: true })
    setTimeout(()=>this.setState({ wasManuallyAddStudentsSuccessful: false }), 2000)
  }

  getImportChoiceIndex = ()=> {
    // Start on the Google Import selection if the popup is open
    return this.props.isGooglePopupOpen ? 1 : 0
  }

  updateStudentRoster = vals => {
    this.props.handleUpdateSection(vals, this.setState({ isEditingRoster: false }))
  }

  onUpsertStudents = vals => {
    const handleSuccess = ()=>setTimeout(this.setState({ isEditingRoster: false }), 500)
    this.props.handleUpsertStudents(vals, handleSuccess)
  }

  onResetPasswords = ()=> {
    this.setState({ showResetConfirmation: false })
    this.props.handleResetSectionPasswords({ sectionId: this.props.section.id })
  }

  //pressing the remove students button from the students roster form
  handleRemoveStudentsButton = ()=> {
    this.setState({ isEditingRoster: false, isRemovingStudents: true })
  }

  //pressing the save roster button from the remove students form
  handleSaveRosterButton = ()=> {
    this.setState({ isEditingRoster: true, isRemovingStudents: false })
  }

  //pressing the transfer students button
  handleOpenTransferStudentsPopup =(values)=> {
    const studentIds = []
    _.map(values.students, student => {if (_.isBoolean(student.isSelected)){studentIds.push(student.id)}})
    if(_.isEmpty(studentIds)){return}
    this.setState((state) => {
      this.props.handleFetchRosters()
      return { isTransferStudentsPopupOpen: true, studentsForRemoval: studentIds, transferStudentsSuccess: false }
    })
  }

  //opening the delete students popup
  handleOpenDeleteStudentsPopup=(values)=> {
    const studentIds = []
    _.map(values, student => {if (_.isBoolean(student.isSelected)){studentIds.push(parseInt(student.id))}})
    if(_.isEmpty(studentIds)){return}
    this.setState({ isDeleteStudentsPopupOpen: true, studentsForRemoval: studentIds })
  }

  //pressing the close button (either popu)
  handleClosePopup = () => {
    this.props.handleClearTransferErrors()
    this.setState( { isTransferStudentsPopupOpen: false, isDeleteStudentsPopupOpen: false, studentsForRemoval: []} )
  }

  //pressing the close button on transfer popup after transfer has occured successfully
  handleTransferSuccessClosePopup = () => {
    this.setState((state)=>{
      this.props.handleFetchSection(this.props.section.id, true)
      return {isTransferStudentsPopupOpen: false, isDeleteStudentsPopupOpen: false, studentsForRemoval: []}
    })
  }

  //pressing the confirm delete students button
  handleDeleteStudents = () => {
    this.props.handleDeleteStudents(this.state.studentsForRemoval,() => { this.setState((state)=>{
      return{studentsForRemoval: [], isDeleteStudentsPopupOpen: false, isEditingRoster: false, isRemovingStudents: false}
    })})
  }

  //transfering to an already-created section
  handleTransferExistingSection = (sectionId) => {
    const values = {
      studentIds: this.state.studentsForRemoval,
      sectionId: sectionId
    }
    this.props.handleTransferStudents(values,() => { this.setState((state)=>{
      return {studentsForRemoval: [], transferStudentsSuccess: true}
    })})
  }

  //transfering to a new class
  handleTransferNewSection = (formValues) => {
    let values = {
      studentIds: this.state.studentsForRemoval,
      sectionName: formValues.name,
      sectionDescription: formValues.description
    }
    if (formValues.course.value == formValues.course.label){
      values.courseName = formValues.course.label
    } else {
      values.courseId = formValues.course.value
    }
    this.props.handleTransferStudents(values,() => { this.setState((state)=>{
      return {studentsForRemoval: [], transferStudentsSuccess: true}
    })})
  }


  sectionFormValues = ()=> {
    const { section } = this.props
    return {
      id:           section.id,
      name:         section.name,
      description:  section.description,
      isCodeActive: section.isCodeActive,
      course:       {
        value: section.course.id,
        label: section.course.name
      }
    }
  }

  alphabetizeStudents = students => {
    return _.orderBy(students, student => [student.profile.lastName ? student.profile.lastName.toUpperCase() : null, student.profile.firstName.toUpperCase() ])
  }

  activityHint = (type) => {
    switch (type) {
      case 'activity':
        return (
        <div>
          <p><FontAwesomeIcon icon={["far", "circle"]} color='#6d5cae'/> Has not created character</p>
          <p><FontAwesomeIcon icon={faAdjust} color='#6d5cae'/> Has created character, but not completed quests yet</p>
          <p><FontAwesomeIcon icon={faCircle} color='#6d5cae'/> Has created character, and completed at least one quest</p>
        </div>
      )
      case 'username/email':
        return `Students use their username/email to log in. 
        If you want your students to use Single-Sign-On, 
        edit this field to match the username/email of 
        their third-party account.`
      default:
        return ''
    }
  }

  onCodeActiveChange = e => {
    const { section } = this.props
      this.props.handleUpdateSection({
        id:           section.id,
        name:         section.name,
        description:  section.description,
        isCodeActive: e,
        course:       {
          value: section.course.id,
          label: section.course.name
        }
    })
  }

  //this function formats student profiles to be used in the upsert students form
  formatStudentProfiles = profiles => {
    return _.map(this.alphabetizeStudents(profiles), s=>{
        delete s.profile.characterName
        return s.profile
      })
  }

  //onboarding check - is there student in the class
  static contextType = OnboardingTeacherContext
  updateOnboarding_hasStudentInClass = (section) =>{
    if(!this.context.isAllComplete && this.context.studentStartTrack.steps.addStudent !== _.indexOf(status,'completed') && !_.isEmpty(section.students)){
      const updateOnboardingCred = {
          stepId:_.indexOf(step_id,'hasPopulatedClass')
        }
        const updateOnboardingTaskComplete = {
           onComplete: json => {
             const errors = json.data.completeOnboardingStep.errors
             if(!_.isEmpty(errors)){
               errors.map(error => console.error(error))
             }
             else{
               const data = json.data.completeOnboardingStep.updatedContext
               const studentTrackUpdate = convertStudentStartTrack(json.data.completeOnboardingStep.updatedContext)
               this.context.setStudentStartTrack(prev => ({
                 ...prev,
                 completedSteps:this.context.studentStartTrack.completedSteps + 1,
                 ...studentTrackUpdate
               }))
               this.context.setIsAllComplete(data.allOnboardingStepsCompleted)
               this.context.setCurrentPath('teacher_studentStartPath')
             }
           },
           onFailure: error => {console.error(error)}
        }
        handleTaskComplete(updateOnboardingTaskComplete, updateOnboardingCred)
    }
  }

  render() {
    const { handleResetSectionPasswords, handleUpsertStudents, importClassroomStudents,  handleGoogleImportPopupClose, fetchGoogleClassrooms, addStudentsSelection, handleUpdateSection, handleVisitTargetSection } = this.props //handlers and state-manipulating functions

    const { isUpsertingStudents, isResettingPasswords, isImporting, isClassroomFetching, isUpdatingSection, isTransferringStudents, wasGoogleImportSuccessful } = this.props //passed-in states

    const { passwordResetErrors, upsertStudentsErrors, importErrors, classroomFetchErrors, updateSectionErrors, transferStudentsErrors } = this.props //errors

    const { googleClassrooms, googleAuthorizationLink, courseCollection, section, rosters, activityIndicator } = this.props //data

    const { showResetConfirmation, isRemovingStudents,isDeleteStudentsPopupOpen, wasManuallyAddStudentsSuccessful, isEditingRoster, autoGenerate, courseValue } = this.state

    this.updateOnboarding_hasStudentInClass(section)

    return(
      <div className='section-wrapper'>
        {showResetConfirmation &&
          <ConfirmationPopup
            title='Are you sure?'
            message={`Press OK to reset passwords for all ${(section.students || []).length} students in ${section.name}. The new passwords will be displayed and printable.`}
            onConfirm={this.onResetPasswords}
            onCancel={()=>this.setState({ showResetConfirmation: false })}
          />
        }
        {!_.isEmpty(section) &&
          <div>
            {/* Section form */}
            <div className='section-form-container no-print'>
              <h1>{section.name}</h1>
              <SectionFormInline
                formValues={this.sectionFormValues()}
                courseCollection={courseCollection}
                courseValue={courseValue}
                onCourseValueChange={val=>this.setState({ courseValue: val })}
                isSubmitting={isUpdatingSection}
                onSubmit={handleUpdateSection}
                errors={updateSectionErrors}
              />
            </div>


            {/* Roster container */}
            {!_.isEmpty(section.students) &&
              <div className='roster-container'>
                <div className='no-print roster-controls pull-right'>
                  {isResettingPasswords && <img className='loading-gif' src={loadingGif}/>}
                  <button type='button'
                    disabled={isResettingPasswords}
                    onClick={()=>this.setState({ showResetConfirmation: true })}
                    className='btn btn-reset btn-default'>
                    Reset All {section.name} Passwords
                  </button>
                  <button type='button' onClick={window.print} className='btn btn-primary'>
                    Print Roster
                  </button>
                </div>
                <h2 className='only-print'>{section.name}</h2>
                <h2 className='no-print'>Student Roster</h2>
                <h3>{pluralize('Student', section.students.length, true)}</h3>
                <p className='no-print' style={{ fontSize: '15px' }}>
                  Please print or save a copy of the information below to distribute to your students. You can always edit your students' passwords, but
                  <b> you can only view them once after they are created.</b>
                </p>
                <div>
                  <div className='only-print'><p>{section.description}</p></div>

                  <div className="tab-pane sm-no-padding active slide-left">
                    <div className="card card-transparent">
                      <div className="table-responsive">
                        {!isEditingRoster && !isRemovingStudents &&
                          <table className="table table-striped" id="stripedTable">
                            <thead>
                              <tr>
                                <th className='one-thirteenth-width activity-indicator-header'>
                                  Activity 
                                  <HintButton
                                    hint={this.activityHint('activity')}
                                    alignment={'left'}
                                    arrowDirection={'down'}
                                    iconColor={'#6D5CAE'}
                                    hintBoxColor={'white'}
                                    hintTextColor={'black'}
                                  />
                                </th>
                                <th className='two-thirteenth-width'>First Name</th>
                                <th className='two-thirteenth-width'>Last Name</th>
                                <th className='four-thirteenth-width'>
                                  Username/Email
                                  <HintButton
                                    hint={this.activityHint('username/email')}
                                    isActivityHint={true}
                                    alignment={'left'}
                                    arrowDirection={'down'}
                                    iconColor={'#6D5CAE'}
                                    hintBoxColor={'white'}
                                    hintTextColor={'black'}
                                  />
                                </th>
                                <th className='four-thirteenth-width'>Password</th>
                              </tr>
                            </thead>
                            <tbody>
                              {_.map(this.alphabetizeStudents(section.students), student => (
                                <tr className='show-row' key={student.id}>
                                  <td className="v-align-middle semi-bold one-thirteenth-width activity-indicator">
                                    {activityIndicator[student.profile.uuid]}
                                  </td>
                                  <td className="v-align-middle semi-bold two-thirteenth-width">
                                    <p>{student.profile.firstName}</p>
                                  </td>
                                  <td className="v-align-middle semi-bold two-thirteenth-width">
                                    <p>{student.profile.lastName}</p>
                                  </td>
                                  <td className="v-align-middle semi-bold four-thirteenth-width">
                                    <p>{student.profile.username}</p>
                                  </td>
                                  <td className="v-align-middle semi-bold four-thirteenth-width">
                                    <p>{student.profile.password || <span className='hint-text'>Password can no longer be viewed</span>}</p>
                                    </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        }
                        {isEditingRoster && !isRemovingStudents &&
                          <StudentRosterForm
                            onSubmit={this.onUpsertStudents}
                            errors={upsertStudentsErrors}
                            isSubmitting={isUpsertingStudents}
                            onCancel={()=>this.setState({ isEditingRoster: false })}
                            onRemoveStudentsClick={this.handleRemoveStudentsButton}
                            activityIndicator={activityIndicator}
                            activityHint={this.activityHint}
                            formValues={{
                              sectionId: section.id,
                              studentProfiles: this.formatStudentProfiles(section.students)
                            }}
                          />
                        }
                        {isRemovingStudents &&
                          <RemoveStudentsForm
                            formValues={{
                              sectionId: section.id,
                              students: this.alphabetizeStudents(section.students)
                            }}
                            onSaveRosterClick={this.handleSaveRosterButton}
                            onDeleteStudentsClick={this.handleOpenDeleteStudentsPopup}
                            onSubmit={this.handleOpenTransferStudentsPopup}
                            activityIndicator={activityIndicator}
                            activityHint={this.activityHint}
                          />
                        }
                      </div>
                    </div>
                  </div>

                  {!isEditingRoster && !isRemovingStudents &&
                    <div className='roster-control-bottom'>
                      <button type='button' onClick={()=>this.setState({ isEditingRoster: true })} className='no-print btn btn-primary edit-roster-button'>Edit Roster</button>
                    </div>
                  }
                </div>
              </div>
            }

            {/* Add/Import students container */}
            <div className='add-students-container no-print'>
              <h2>Add Students</h2>
              <p className='instructions'>You have three options for adding students.</p>
              <VerticalTabBox
                initialIndex={this.getImportChoiceIndex()}
                tabsHtml={[
                  <div className='add-students-option'>
                    <h4>Registration Code</h4>
                    <p>Have students register with a code and create their own accounts</p>
                  </div>,
                  <div className='add-students-option'>
                    <h4>Google Import</h4>
                    <p>Import student emails and names from Google Classroom</p>
                  </div>,
                  <div className='add-students-option'>
                    <h4>Manually Add</h4>
                    <p>Manually create accounts for your students</p>
                  </div>
                ]}
                contentsHtml={[
                  <div className='add-students-instruction'>
                    <div className='code-switch-container'>
                      <Switch
                        className="switch-class"
                        name='useRegistrationCode'
                        type='checkbox'
                        onChange={this.onCodeActiveChange}
                        options={{size: 'large', color: '#674ea7' }}
                        checked={section.isCodeActive}
                      />
                          <p>Class code registration:<br/> <b>{section.isCodeActive ? 'ON' : 'OFF'}</b></p>
                    </div>
                    {section.isCodeActive &&
                      <div>
                        <p>Have students go to <a href='https://www.tytoonline.com/students'>www.tytoonline.com/students</a> to create their accounts and register for your class with this code:</p>
                        <span className="label font-montserrat">{section.registrationCode}</span>
                        <br/><br/>
                          <p>Students will only need this code when they first register, or when they first join your class if they already have an account. <b>We recommend turning it off after you have verified all students have created one account/joined your class.</b></p>
                      </div>
                    }
                    {!section.isCodeActive &&
                      <div>
                        <p> If the class code is turned on, your students will be able to create their own username and password. You will be able to edit them if necessary.</p>
                      </div>
                    }

                  </div>,
                  <div className='add-students-instruction'>
                    <p>Importing from Google Classroom will automatically create accounts for the students. <b>We'll email them their auto-generated password</b> once they are imported.</p>
                    <br/>
                    <p>The students can use Google Single Sign On in the new browser version, <b>or</b> use their username/password combination (all platforms) to log in.</p>
                    <br/>
                    <Link to='?import=true' className='btn btn-lg btn-primary classroom-import'>Import</Link>
                  </div>,
                  <div className='add-students-instruction'>
                    <p>You can only view passwords immediately after creating a student. We advise that you print the roster after you create and update students. You can always change their usernames or passwords if they are forgotten or need to be reset.</p>

                    <StudentsForm
                      formValues={{ sectionId: section.id, studentProfiles: [] }}
                      autoGenerate={autoGenerate}
                      onSubmit={handleUpsertStudents}
                      errors={upsertStudentsErrors}
                      isSubmitting={isUpsertingStudents}
                      wasSubmitSuccessful={wasManuallyAddStudentsSuccessful}
                      onChangeAutoGenerate={()=>this.setState({ autoGenerate: !autoGenerate })}
                    />
                  </div>
                ]}
                />

              {this.props.isGooglePopupOpen &&
                <GoogleClassroomPopup
                  wasSuccessful={wasGoogleImportSuccessful}
                  importClassroomStudents={importClassroomStudents}
                  isImporting={isImporting}
                  importErrors={importErrors}
                  onClose={handleGoogleImportPopupClose}
                  section={section}
                  fetchClassrooms={fetchGoogleClassrooms}
                  classrooms={googleClassrooms}
                  isFetching={isClassroomFetching}
                  fetchErrors={classroomFetchErrors}
                  authLink={googleAuthorizationLink}
                />
              }
              {this.state.isTransferStudentsPopupOpen &&
                <TransferStudentsFormPopup
                  courseCollection={courseCollection}
                  rosters={rosters}
                  handleTransferExistingSection={this.handleTransferExistingSection}
                  transferSuccess={this.state.transferStudentsSuccess}
                  onClose={this.handleClosePopup}
                  handleSubmit={this.handleTransferNewSection}
                  handleVisitTargetSection={handleVisitTargetSection}
                  handleSuccessClose={this.handleTransferSuccessClosePopup}
                  errors={transferStudentsErrors}
                  isSubmitting={isTransferringStudents}
                  currentSectionId={section.id}
                />
              }
              {isDeleteStudentsPopupOpen &&
                <ConfirmationPopup
                  title='Delete Students'
                  message={'You are about to delete ' + this.state.studentsForRemoval.length + ' student account and all of its progress data. Are you sure you want to proceed?'}
                  onCancel={this.handleClosePopup}
                  onConfirm={this.handleDeleteStudents}
                />
              }
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Section
